let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-select';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Champ de sélection (select)',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Autorise les utilisateurs à choisir une option dans une liste de plusieurs options.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/7029dd-champ-de-selection-select)
        `,
      },
    },
  },
};

export default meta;

function htmlContent() {
  return /* HTML */ `
    <option>Option 1</option>
    <option>Option 2</option>
    <option>Option 3</option>
  `;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = true;
  const slottedLabel = 'content';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent();
  }

  return element;
};

export const Default = Template.bind({});
Default.args = {
  placeholder: 'Mon placeholder',
  label: 'Mon label',
  name: 'select',
  hint: "Mon texte d'assistance",
  required: true,
  showHintIcon: false,
};
